import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import { BreakpointService } from '@principle-theorem/ng-shared';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'pr-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    LetDirective,
    RouterModule,
  ],
})
export class NavbarComponent {
  showMobileMenu$ = new BehaviorSubject<boolean>(false);

  constructor(
    public org: OrganisationService,
    public breakpoint: BreakpointService
  ) {}

  toggleMenu(): void {
    this.showMobileMenu$.next(!this.showMobileMenu$.value);
  }
}
